//@ts-nocheck
import React, { useEffect, useRef, useState } from 'react';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { useParams } from 'react-router-dom';
import { createCandidateApplication } from '../../../store/slices/application/applicationSlice';
import { toast } from 'sonner';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import ConfettiExplosion from 'react-confetti-explosion';
import ApplicationDyanamic from './ApplicationDyanamic';
import { applyApplicationQuestion, createApplicationQuestion } from '../../../store/slices/task/taskSlice';

const AppQuestionnaire = () => {

  const [formData, setFormData] = useState({
    candidate_name: '',
    candidate_email: '',
    candidate_phone_status: '',
    candidate_location: '',
    profile_summary_status: '',
    education_details_status: '',
    work_experience_status: '',
    links: [],
    resume: null,
    cover_letter_status: '',
  });


  const [yesNoAnswers, setYesNoAnswers] = useState({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const locations = useAppSelector((state) => state?.jobs?.locationDetails);
  const [formSteps, setFormSteps] = useState<FormElement[]>([]);
  const [integrationResponse, setIntegrationResponse] = useState<any[]>([]);
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const { base_slug, jobId, appId, QuestionId } = useParams();
  const [uploading, setUploading] = useState(false);
  const [uploadedResumeUrl, setUploadedResumeUrl] = useState<string | null>(null);
  const [resumeFile, setResumeFile] = useState<File | null>(null);
  const { uploadResumeStatus, createCandidateData, uploadResumeError } = useAppSelector((state) => state.application);
  const [resumeError, setResumeError] = useState('')
  const [educationData, setEducationData] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [showConfetti, setShowConfetti] = useState(false);
  const [saveSuccesMessage, setSaveSuccesMessage] = useState('')
  const formRef = useRef<HTMLFormElement>(null);
  const dispatch = useAppDispatch();
  const [applicationData, setApplicationData] = useState(null)
  const [loadingApplicationData, setLoadingApplicationData] = useState(false); // NEW


  // apply job

  useEffect(() => {
    const applyJob = async () => {
      setLoadingApplicationData(true); // Start loading
      try {
        const data = await dispatch(applyApplicationQuestion({ id: QuestionId })).unwrap();
        setApplicationData(data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingApplicationData(false); // Stop loading
      }
    };

    applyJob();
  }, [dispatch, QuestionId]);




  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

  };


  const handleSubmit = (e: any) => {
    e.preventDefault();

    // Validate all fields before submission
    const formErrors: { [key: string]: string } = {};
    let hasErrors = false;

    if (hasErrors) {
      return;
    }
  };

  const handleSubmitApplication = async (dynamicFormData: any) => {
    setErrors({});
    let hasErrors = false;
    const allErrors: { [key: string]: string } = {};

    if (hasErrors) {

      toast.error('Please fill all required fields');
      formRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setErrors(allErrors);
      return;
    }


    try {
      setLoadingForm(true);
      const applicationResponse = await dispatch(createApplicationQuestion({
        job_id: jobId,
        questionId: QuestionId,
        answer: JSON.stringify(dynamicFormData.answers)
      })).unwrap();

      // Combine all form data
      const completeFormData = {
        ...formData,
        ...dynamicFormData,
        applicationId: applicationResponse.id
      };


      setSaveSuccesMessage(applicationResponse);
      setShowThankYouMessage(true);
      // setShowConfetti(true);
      toast.success('Application submitted successfully!');


    } catch (error: any) {
      console.error('Application submission error:', error);
      toast.error(error.message || 'Failed to submit application. Please try again.');
      // window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoadingForm(false);
    }
  };


  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(date);
  };


  return (
    <div className='mt-0 py-8 h-[calc(100vh_-_104px)] overflow-y-auto'>
      <div className='w-full max-w-[710px] mx-auto'>
        {
          applicationData?.status === 'pending' &&

          <form onSubmit={handleSubmit} className="space-y-8" ref={formRef}>
            <h2 className='text-lg font-semibold capitalize'>questionnaire</h2>

            <hr className="mt-6" />
            {
              !showThankYouMessage &&
              <div className='!pt-0 !mt-2'
                className={`${applicationData?.questions?.length > 0 ? 'pt-0 !mt-0' : '!pt-0 !mt-0'}`}
              >
                {loadingApplicationData ? (
                  <div className="flex items-center justify-center relative z-50 h-[calc(100vh_-_260px)]">
                    <div className="simple-spinner-loader">
                      <span></span>
                    </div>
                  </div>
                ) : (
                  <ApplicationDyanamic
                    steps={applicationData?.questions}
                    formSteps={formSteps}
                    onSubmit={handleSubmitApplication}
                    integrationResponse={integrationResponse}
                    setIntegrationResponse={setIntegrationResponse}
                    setShowThankYouMessage={setShowThankYouMessage}
                    showThankYouMessage={showThankYouMessage}
                    setLoadingForm={setLoadingForm}
                    loadingForm={loadingForm}
                    parentFormData={formData}
                  />
                )}

              </div>
            }


          </form>
        }


        {
          applicationData?.status === 'done' && (

            <>

              <div className="mt-[50px] mb-[34px] p-4 bg-green-100 text-green-800 border border-green-300 rounded-md relative">
                <div className='flex items-center gap-x-4'>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 lg:size-7">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
                  </svg>
                  <div className='flex flex-col items-start gap-y-1'>
                    <span className='text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-full p-0 mt-0'>
                      Application ID:
                      <span className='ml-1'>  {saveSuccesMessage?.data?.id || applicationData?.app_id}</span>
                    </span>
                    {
                      saveSuccesMessage?.data?.submitted_at &&
                      <p className='text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-full p-0 mt-0'>
                        Received on:
                        <span className='ml-1'>{formatDate(saveSuccesMessage?.data?.submitted_at)}</span>
                      </p>
                    }
                    {
                      applicationData?.submitted_at &&
                      <p className='text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-full p-0 mt-0'>
                        Received on:
                        <span className='ml-1'>{formatDate(applicationData?.submitted_at)}</span>
                      </p>
                    }
                  </div>
                </div>
                <h4 className=' text-green-800 my-[8px] lg:my-[4px] h-[100%] w-full p-0 text-[16px] md:text-[16px] lg:text-[16px] leading-5 lg:leading-[30px] font-medium flex items-start md:items-center lg:items-center gap-2'>
                  Thank you! Your responses has been submitted successfully.
                </h4>
                <p className='text-[16px] md:text-[16px] lg:text-[16px] leading-6 font-normal text-green-800 w-full p-0 m-0'>
                  Our team will review it, and we'll get back to you soon.
                </p>


                {showThankYouMessage && (
                  <div className="flex justify-center items-center absolute inset-0">
                    <ConfettiExplosion />
                  </div>
                )}
              </div>

            </>
          )
        }

      </div>


    </div>
  );
};

export default AppQuestionnaire;